import { useConsoleProjectId } from '@api/console';
import { appInstance } from '@api/setup';
import { AuthProvider } from '@descope/react-sdk';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/system';
import { isProd } from '@utils/api';
import { IS_TEST_MODE } from 'constants/global';
import { APP_ROUTES } from 'constants/routes';
import getLightTheme from 'constants/Theme/LightTheme';
import { LoginPage, NotFoundPage } from 'pages';
import { LoginContainer } from 'pages/containers';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { useEffectOnce } from 'usehooks-ts';
import AuthenticatedApp from './AuthenticatedApp';

const FLOW_BASE_ASSETS_KEY = 'base.content.url';

const AppRoutes = () => {
	const loginWrapper = (page: JSX.Element) => (
		<ThemeProvider theme={getLightTheme()}>
			<CssBaseline enableColorScheme />
			<LoginContainer>{page}</LoginContainer>
		</ThemeProvider>
	);

	const { data: consoleProjectId } = useConsoleProjectId();

	useEffectOnce(() => {
		// enforce dev flow assets if not prod.
		const url = window.localStorage.getItem(FLOW_BASE_ASSETS_KEY);
		if (!IS_TEST_MODE && !url && !isProd()) {
			window.localStorage.setItem(
				FLOW_BASE_ASSETS_KEY,
				'https://static.descope.org/pages'
			);
			window.location.reload();
		}
	});

	return consoleProjectId ? (
		<AuthProvider
			projectId={consoleProjectId!}
			baseUrl={appInstance.defaults.baseURL}
			sessionTokenViaCookie
		>
			<Routes>
				<Route path={APP_ROUTES.login} element={loginWrapper(<LoginPage />)} />
				<Route path="*" element={<AuthenticatedApp />} />
				<Route path={APP_ROUTES.notFound} element={<NotFoundPage />} />
			</Routes>
		</AuthProvider>
	) : null;
};

export default AppRoutes;
